import {Routes} from '@angular/router';

export const WebsitePublicRoutes: Routes = [
    {
        path: '',
        children: [
        ]
    }
];
